import React, { useEffect, useRef, useState } from 'react' // 1. Added useRef
import {
  GraphOuterWrapper,
  GraphInnerWrapper,
  Graph,
} from '../style'
import BrandImageryRow from '../BrandImageryRow/BrandImageryRow'
import GraphScaleWrapperComponent from '../GraphScaleWrapperComponent/GraphScaleWrapperComponent'
import ChartLegend from '../ChartLegend/ChartLegend'

const sortingDataEntityWise = (data) => {
  const arrBrand = data.filter((f) => f.entityType === 'Brand')
  const arrCompetitorBrand = data.filter((f) => f.entityType === 'CompetitorBrand')
  const arrRest = data.filter((f) => !['Brand', 'CompetitorBrand'].includes(f.entityType))
  return [...arrBrand, ...arrCompetitorBrand, ...arrRest]
}

const Tab0Content = ({
  rows,
  canMove,
  showExpandAllCTA,
  editTitleFlag,
  editTitleClicked,
  showLevel2Func,
  onChange,
}) => {

  const graphRef = useRef(null)
  const [counter, setCounter] = useState(0)

  useEffect(() => {
    if (graphRef.current && counter > 0 && rows.length>0) {
      const expandButtons = graphRef.current.querySelectorAll('.brandImageryRowAppendices.brandImageryRow .btnExpand')
      if (expandButtons.length > 0) {
        const lastBtn = expandButtons[expandButtons.length - 1]
        lastBtn.click()
        setTimeout(() => {
          lastBtn.click()
        }, 1000)
      } else {
        setCounter(counter+1)
      }
    } else if (counter===0) {
      setCounter(counter+1)
    }
  }, [counter])

  return (
    <GraphOuterWrapper>
      <GraphScaleWrapperComponent />
      <GraphInnerWrapper className='GraphScaleWrapper'>
        <Graph ref={graphRef} simulator={canMove ? 'yes' : 'no'}>
          {rows.map((rowData, index) => {
            const rData = rowData
            rData.data = sortingDataEntityWise(rData.data)
            return (
              <BrandImageryRow
                showExpandAllCTA={showExpandAllCTA}
                canMove={canMove}
                key={index}
                index={index}
                onChange={onChange}
                row={rData}
                editTitleFlag={editTitleFlag}
                editTitleClicked={editTitleClicked} 
                showLevel2Func={showLevel2Func}
              />
            )
          })}
        </Graph>
      </GraphInnerWrapper>
      <GraphScaleWrapperComponent />
      <ChartLegend type='default' />
    </GraphOuterWrapper>
  )
}

export default Tab0Content
